import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]

import type { Toast } from '@components/Toast/Toast';
import { getTranslations } from '@services/translations';


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
    toast: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const translations = getTranslations();


const emit = __emit;

const close = () => {
  emit('close');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toast", `toast--${__props.toast.type}`])
  }, [
    _createElementVNode("span", null, _toDisplayString(__props.toast.message), 1 /* TEXT */),
    _createElementVNode("button", {
      type: "button",
      onClick: close,
      "aria-label": _unref(translations)['bookings.common.close']
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "icon icon--cross toast__close" }, null, -1 /* CACHED */)
    ]))], 8 /* PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}
}

})